enum DriverContractListingByTaxiFilterType {
  BILLING_MODEL = "BILLING_MODEL",
}

export default DriverContractListingByTaxiFilterType;
